import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { RangeMixin } from '../../mixins/components/RangeMixin';

/**
 * A native ["range" input](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range)
 * element, also commonly known as a slider.
 *
 * @related ['Slider']
 * @since 6.11.0
 */
var Range = /*#__PURE__*/styled( /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("input", _extends({
    type: "range"
  }, props, {
    ref: ref
  }));
})).withConfig({
  displayName: "Range",
  componentId: "c11n-8-107-0__sc-afacwm-0"
})(["", ""], RangeMixin);
Range.displayName = 'Range';
Range.propTypes = {
  /** https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range#max */
  max: PropTypes.string.isRequired,
  /** https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range#min */
  min: PropTypes.string.isRequired,
  /** https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range#step */
  step: PropTypes.string
};
Range.defaultProps = {
  step: '1'
};

/** @component */
export { Range };